import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { apiClient } from 'store/api-client';
import { configSelector } from 'store/config/selectors';
import { currentToken } from 'store/user/selectors';

export const useClient = () => {
  const config = useSelector(configSelector);
  const token = useSelector(currentToken);
  const client = useMemo(() => apiClient({ user: { token }, config }), [config, token]);

  return client;
};
